import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { PDA1010_R01Card, PDA1010_R01DetailDto } from "./PDA1010_R01Dto";

const baseUrl = `${config.apiUrl}/PDA1010_R01`;

/** 현재 PLC 최신값을 백엔드에서 그룹화한 카드 목록으로 조회합니다. */
export const getPDA1010_R01List = async () => {
  return getData<ResponseDto<PDA1010_R01Card[]>>(`${baseUrl}/search`);
};

/** 선택한 카드의 지정 기간 PLC 측정 이력을 조회합니다. */
export const getPDA1010_R01DetailList = async (
  cardCode: string,
  startDateTime: string,
  endDateTime: string
) => {
  return getData<ResponseDto<PDA1010_R01DetailDto[]>>(
    `${baseUrl}/detail/${cardCode}`,
    {
      params: {
        startDateTime,
        endDateTime,
      },
    }
  );
};
